module.exports = __webpack_public_path__ + "media/images/application/template/star-0f03ee084556df4c7636334588311ad4.svg";